import {Injectable} from '@angular/core';
import {environment} from './../../environments/environment';
import * as _sh from "lodash";


@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  public config: any = {};
  public version: any = null;

  constructor() {
    const projectData = require('./../../environments/environment.json');
    this.version = projectData['version'];
    this.config = _sh.extend(environment.commonConfig, environment[projectData.project]);
  }

  getServer() {
    let exportServer = this.config.ExportServer ? this.config.ExportServer : 'https://export-hulk.jiuling.sinotrans.com';
    return {
      'NodeJsApi': this.config.NodeJsServer + '/api',
      'AutoInsertAPi': this.config.AutoPlatform + '/servlet/AutoInsertServlet',
      'NodeMongoSql': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/mysqlServlet/mongoSql',
      'redisServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/redisServlet',
      'ImageBase64': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/mysqlServlet/getImageBase64',
      'NodeJsonFile': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/jsonfileServlet/getfileWithData',
      'GetJsonFile': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/jsonfileServlet/getfile',
      'mongoServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/mongoServlet/api',
      'excelServlet': exportServer + '/' + this.config.NodeJsApiVersion + '/excelServlet/getExcel',
      'countServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/countServlet/count',
      'QaAnalysisServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/QaAnalysisServlet',
      'devToolsServletColumns': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/devToolsServlet/columns',
      'serverTime': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/md5Servlet/getServerTime',
      'importServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/importServlet/putExcel',
      'baiduMapServlet': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/baiduMapServlet/search',
      'execWordProcess': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/wordProcessServlet/execWordProcess',
      'buildData': this.config.NodeJsServer + '/' + this.config.NodeJsApiVersion + '/dataCenterServlet/buildData',
      'SystemTest': 'http://hdbsthor-system.wmsb2b.com'
    };
  }
}
